// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Messages-Header-__styles__wrapper--1nkib","text":"src-components-Messages-Header-__styles__text--tKS5m","topsIndex":"src-components-Messages-Header-__styles__topsIndex--q-GIz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Header/styles.css
// module id = 1971
// module chunks = 0